import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-input-date",
  templateUrl: "./input-date.component.html",
  styleUrls: ["./input-date.component.scss"],
})
export class InputDateComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Input() control: FormControl;
  @Input() placeholder: string = "Select a Date";
  @Input() onlyFutureDates: boolean; // avoid being able to select previous dates
  @Input() avoidToday: boolean; // avoid being able to select today's date
  @Input() useUTC: boolean = false; // set input/outputs/comparisons with UTC
  @Input() appendTo = 'body'
  @Input() dateControl = null;
  public minDate: Date | null = null;
  public disabledDates: Date[] = [];
  public dateFormat: string = "mm/dd/yy";

  destroy$ = new Subject();

  constructor() {}

  ngOnInit(): void {
    this.setupDateFilters();

    if (this.control) {
      this.control.valueChanges.subscribe((value) => {
        if (value instanceof Date) {
          // Convert to UTC or keep as local time based on useUTC setting
          const date = new Date(value);
          if (this.useUTC) {
            // Set to start of day in UTC
            date.setUTCHours(0, 0, 0, 0);
          } else {
            // Set to start of day in local time
            date.setHours(0, 0, 0, 0);
          }
          this.control.setValue(date, { emitEvent: false });
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private setupDateFilters(): void {
    // Create today's date at start of day
    const today = new Date();
    
    if (this.useUTC) {
      today.setUTCHours(0, 0, 0, 0);
    } else {
      today.setHours(0, 0, 0, 0);
    }

    if (this.onlyFutureDates) {
      this.minDate = today;
    }

    if (this.avoidToday) {
      if (this.onlyFutureDates) {
        // If we're already filtering for future dates, adjust minDate to tomorrow
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        this.minDate = tomorrow;
      } else {
        // Otherwise, add today to disabled dates
        this.disabledDates = [new Date(today)];
      }
    }
  }
}
